var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex",class:!_vm.styles ? '' : !_vm.styles.alignItems ? 'align-items-center' : '',style:(_vm.styles)},_vm._l((_vm.fields),function(field){return _c('component-renderer',{key:field.id,class:field.properties.grid ? `col-lg-${field.properties.grid.columns}` : '',attrs:{"field":field}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }